import {Component} from "@angular/core";
import { AuthService } from "../auth/auth.service";
import { faArrowCircleRight } from "@fortawesome/free-solid-svg-icons/faArrowCircleRight";
import { SupportService } from "../../support/service/support.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent {
  public faArrowCircleRight = faArrowCircleRight;

  public pin: string;

  constructor(
    public readonly authService: AuthService,
    public readonly supportService: SupportService,
  ) {
    this.pin = "";
  }

  public async login(): Promise<void> {
    try {
      const result = await this.authService.login(this.pin);
      if (result != null) {
        alert(result);
      }
    } catch (e) {
      alert(e.message);
    }
    this.pin = "";
  }
}
